
























import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbBtn, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';
import { Link } from '@/models/common/link';
import { Guid } from 'guid-typescript';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbBtn,
        mdbAlert,
        mdbIcon
    }
})
export default class EditOtherLinks extends Vue {
    @Prop(Array) private links!: Link[];

    private beforeMount(): void {
        this.links.forEach((link: any) => {
            link.id = Guid.create().toString();
        });
    }

    private addLink(): void {
        const link: any = new Link();
        link.id = Guid.create().toString();
        this.links.push(link);
    }

    private removeLink(index: number): void {
        this.links.splice(index, 1);
    }
}
